

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const GoogleCallback = ({ setUser, setError, setOpenDialog }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    // ✅ Check if there is an error from backend
    const error = params.get("error");
    if (error) {
      setError({ message: error });
      setOpenDialog(true);
      return; 
    }

    const token = params.get("token");
    const userId = params.get("user_id");
    const role = params.get("role");
    const googleuserApiUrl = `${process.env.REACT_APP_GET_GOOGLE_USER_API}/${userId}`;

    if (token && userId) {
      sessionStorage.setItem("token", token);
      sessionStorage.setItem("userId", userId);

      fetch(googleuserApiUrl, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then(res => res.json())
        .then(userData => {
          setUser(userData);
          if (role === "resident") navigate("/services");
          else navigate("/");
        })
        .catch(err => {
          console.error("Error fetching user:", err);
          navigate("/login");
        });
    } else {
      navigate("/login");
    }
  }, [navigate, setUser, setError, setOpenDialog]);

};

export default GoogleCallback;
